import { ArrowPathIcon } from '@heroicons/react/24/outline'

import { anim, prog, pv, stagger } from '../../../motion'
import { Line, Words } from '../../../v2/kit'
import { useCopy } from '../../i18n'

const TONES = ['var(--blue)', 'var(--green)', 'var(--yellow)']

// Drei große Ziffern füllen sich nacheinander, eine Linie verbindet sie
export default function DemoSteps() {
  const c = useCopy('schritte')

  return (
    <div className='cin-pad'>
      <div className='cin-head'>
        <Line at={[0, 0.06]} className='cin-eyebrow'>
          {c.eyebrow}
        </Line>
        <h2 className='cin-title'>
          <Words text={c.title} at={[0.02, 0.16]} />
        </h2>
        <Line at={[0.12, 0.18]} y={16} className='dm-sub'>
          {c.sub}
        </Line>
      </div>

      <div className='dm-steps'>
        <div className='dm-steps__rail'>
          <i style={{ ...prog([0.2, 0.74]), transform: 'scaleX(var(--p))' }} />
        </div>
        {c.steps.map((s, i) => (
          <div
            key={s.title}
            className='dm-step'
            style={{
              ...pv('f', stagger(0.2, 0.2, 0.08, i)),
              '--tone': TONES[i]
            }}
          >
            <div className='dm-step__num'>
              <span className='dm-step__outline'>{i + 1}</span>
              <span className='dm-step__fill'>{i + 1}</span>
            </div>
            <h3
              className='dm-step__title'
              style={anim({ at: stagger(0.22, 0.2, 0.08, i), y: 30 })}
            >
              {s.title}
            </h3>
            <p
              className='dm-step__text'
              style={anim({ at: stagger(0.25, 0.2, 0.08, i), y: 30 })}
            >
              {s.text}
            </p>
          </div>
        ))}
      </div>

      <div className='dm-addon' style={anim({ at: [0.8, 0.88], y: 30 })}>
        <ArrowPathIcon className='dm-addon__icon' />
        <span>
          <b>{c.addon}</b> {c.addonText}
        </span>
      </div>
    </div>
  )
}
